export const GraphType = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  QUARTER: 'quarter',
  YEAR: 'year',
}

export const UserRoles = {
  ADMIN: 'admin',
  USER: 'user',
  ORGANISER: 'organiser',
}

export const UserRoleFilter = [
  // { label: 'All', value: null },
  { label: 'Admin', value: UserRoles.ADMIN },
  { label: 'User', value: UserRoles.USER },
  { label: 'Organiser', value: UserRoles.ORGANISER },
]

export const DeviceTypes = {
  IOS: 'iOS',
  ANDROID: 'Android',
  WEB: 'Web',
}

export const SubscriptionTypes = {
  FREE: 'free',
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  SEMI_ANNUAL: 'semiAnnual',
  YEARLY: 'yearly',
  CUSTOM: 'custom',
}

/** Revenue line item types returned on payment history rows */
export const RevenueTransactionType = {
  SUBSCRIPTION_IAP: 'subscriptionIap',
  SUBSCRIPTION_FLOUCI: 'subscriptionFlouci',
  SUBSCRIPTION_STRIPE: 'subscriptionStripe',
  EVENT_BOOKING_FLOUCI: 'eventBookingFlouci',
  EVENT_BOOKING_STRIPE: 'eventBookingStripe',
}

export const revenueTransactionTypeLabels = {
  [RevenueTransactionType.SUBSCRIPTION_IAP]: 'Subscription (In-App)',
  [RevenueTransactionType.SUBSCRIPTION_FLOUCI]: 'Subscription (Flouci)',
  [RevenueTransactionType.SUBSCRIPTION_STRIPE]: 'Subscription (Stripe)',
  [RevenueTransactionType.EVENT_BOOKING_FLOUCI]: 'Event booking (Flouci)',
  [RevenueTransactionType.EVENT_BOOKING_STRIPE]: 'Event booking (Stripe)',
}

export const RevenueTransactionTypeFilterOptions = Object.entries(
  revenueTransactionTypeLabels,
)
  .map(([value, label]) => ({ label, value }))
  .sort((a, b) => a.label.localeCompare(b.label))
/** Matches backend OrganiserRequestStatus */
export const OrganiserRequestStatus = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
}

export const PayoutRequestStatus = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
}

export const AdjustEventType = {
  Install: 'install',
  SocialLogin: 'socialLogin',
  SocialRegister: 'socialRegister',
  Register: 'register',
  CompleteRegistration: 'completeRegistration',
  EventCreated: 'eventCreated',
  EventDeleted: 'eventDeleted',
  EventShared: 'eventShared',
  EventViewed: 'eventViewed',
  GroupCreated: 'groupCreated',
  GroupDeleted: 'groupDeleted',
  GroupShared: 'groupShared',
  GroupViewed: 'groupViewed',
  Login: 'login',
  Logout: 'logout',
  Purchase: 'purchase',
  Subscribe: 'subscribe',
}

const pascalToSpacedLabel = (value) => value.replace(/([A-Z])/g, ' $1').trim()

export const AdjustEventTypeLabels = Object.fromEntries(
  Object.entries(AdjustEventType).map(([key, value]) => [
    value,
    pascalToSpacedLabel(key),
  ]),
)

export const getAdjustEventTypeLabel = (type) =>
  AdjustEventTypeLabels[type] ?? type ?? '-'

export const AdjustEventTypeFilter = Object.entries(AdjustEventTypeLabels)
  .map(([value, label]) => ({ label, value }))
  .sort((a, b) => a.label.localeCompare(b.label))

export const AdjustUserIdFilter = {
  ALL_EVENTS: 'allEvents',
  ONLY_WITH_USER_ID: 'onlyWithUserId',
}

export const AdjustUserIdFilterOptions = [
  { label: 'All events', value: AdjustUserIdFilter.ALL_EVENTS },
  { label: 'With user ID only', value: AdjustUserIdFilter.ONLY_WITH_USER_ID },
]

export const AdjustOrganicFilter = {
  ALL: 'all',
  ORGANIC: 'organic',
  NON_ORGANIC: 'nonOrganic',
}

export const AdjustOrganicFilterOptions = [
  { label: 'All', value: AdjustOrganicFilter.ALL },
  { label: 'Organic only', value: AdjustOrganicFilter.ORGANIC },
  { label: 'Non-organic only', value: AdjustOrganicFilter.NON_ORGANIC },
]
